import { UserProfile } from '@/interface/profile';

export const fullName = (userProfile?: UserProfile | null) => {
  const profileData = userProfile?.value?.[0];
  const firstName = profileData?.MemberFirstName ?? '';
  const lastName = profileData?.MemberLastName ?? '';

  if (firstName && lastName) return `${firstName} ${lastName}`;
  if (firstName) return `${firstName}`;
  if (lastName) return `${lastName}`;
  return '';
};
